module.exports = __webpack_public_path__ + "img/pecas.313b6ecf.jpg";